import useInView from '../../hooks/useInView';
import './AnimateOnScroll.css'; // contains your custom animations

const AnimateOnScroll = ({ children, animationClass = 'fade-in-up', baseClass = '' }) => {
  const [ref, isVisible] = useInView({ threshold: 0.1 });

  const classNames = `${baseClass} ${isVisible ? animationClass : 'hidden'}`;

  return (
    <div ref={ref} className={classNames}>
      {children}
    </div>
  );
};

export default AnimateOnScroll;